// custom Parse File for
// meta data support (original filename, filesize)
import Parse from 'parse'
import {FileVM} from '@/models/file'
import sanitize from '@/utils/sanitize'

function ParseFile(opts) {
    if (typeof(opts) === 'string') {
        opts = {id: opts};
    } else if (opts instanceof File) {
        opts = {name: opts.name, data: opts};
    } else if (opts instanceof FileVM) {
        return opts;
    }
    var object_id = opts.id,
        file = FileVM(object_id ? object_id : undefined);
    // ['name', 'data', 'type']
    Object.keys(opts).forEach((key) => {
        if (['id', 'data'].indexOf(key) === -1 && opts.hasOwnProperty(key)) {
            file[key] = opts[key];
        }
    });
    if (opts.data) {
        var name = sanitize(file.name || opts.data.name);
        file.file = new Parse.File(name, opts.data, file.type);
        file.size = (typeof(opts.size) !== 'undefined') ? opts.size : opts.data.size;
    }
    return file;
}

export default ParseFile



// WEBPACK FOOTER //
// ./src/utils/parse-file.js